<template>
  <div :id="componentId" class="sp1-partners" :style="sectionStyle">
    <div class="sp1-partner-list">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['sp1-partner-item', item.pictureType === 1 ? 'is-short' : 'is-long', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img
          class="sp1-partner-image"
          referrerpolicy="no-referrer"
          :src="item.pictureUrl"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partners',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_14'
    }
  },
  data() {
    return {
      backgroundImage: require('../assets/img/bottom_bg.png'),
      items: [
        {
          pictureUrl: require('../assets/img/partners_short.png'),
          pictureType: 1,
          jumpType: 1,
          linkAddress: ''
        },
        {
          pictureUrl: require('../assets/img/partners_long.png'),
          pictureType: 2,
          jumpType: 2,
          linkAddress: 'https://www.example.com/partners'
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '2000px',
        marginLeft: '-300px',
         padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return;
      window.open(item.linkAddress, '_blank');
    }
  }
};
</script>

<style scoped>
.sp1-partners {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.sp1-partner-list {
  display: flex;
  margin-top: 28px;
}

.sp1-partner-item {
  display: block;
  height: 162px;
  flex-shrink: 0;
}

.sp1-partner-item.is-short {
  width: 400px;
}

.sp1-partner-item.is-long {
  width: 976px;
  margin-left: 23px;
}

.sp1-partner-item.is-link {
  cursor: pointer;
}

.sp1-partner-item.is-link:hover {
  opacity: 0.9;
}

.sp1-partner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
